import { Tooltip } from 'antd';
import {InfoCircleOutlined }from "@ant-design/icons";

const Tooltipstandardize = () => (
  <Tooltip title=" Data type - Object and Date are not allowed">
    <span><InfoCircleOutlined /></span>
  </Tooltip>
);

export default Tooltipstandardize;